/* eslint-disable react/react-in-jsx-scope */
import type { ComponentType } from 'react';
import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import type { SignInPageProps } from '@backstage/plugin-app-react';

const azureProvider = {
  id: 'azure-auth-provider',
  title: 'Sign In',
  message: 'Sign in using Azure',
  apiRef: microsoftAuthApiRef,
};

/**
 * Wraps stock {@link @backstage/core-components#SignInPage}:
 * - `app.enableGuestSignIn`: Guest + Microsoft cards (multi-provider).
 * - Otherwise: Microsoft-only with `auto` (single-provider), same as production default.
 *
 * Guest sign-in still requires `auth.providers.guest` in backend config; this flag only
 * controls the UI.
 */
export function createCerebroSignInPage(
  // SignInPage from core-components uses a union of single- and multi-provider props; keep loose.
  SignInPage: ComponentType<any>,
): ComponentType<SignInPageProps> {
  function CerebroSignInPage(props: SignInPageProps) {
    const config = useApi(configApiRef);
    const guest = config.getOptionalBoolean('app.enableGuestSignIn') ?? false;

    if (guest) {
      return <SignInPage {...props} providers={['guest', azureProvider]} />;
    }

    return <SignInPage {...props} auto provider={azureProvider} />;
  }

  return CerebroSignInPage;
}
